import { useQuery } from 'react-query'
import { useOtoscopyService } from '../services'
import { defaultQueryOptions } from 'constants/'
import { logFactory } from 'utils'
import { QueryOptions } from 'types'

const hookName = 'useOtoscopies'
const log = logFactory(hookName)

interface Params {
  customerGid?: string
}

const useOtoscopies = ({ customerGid }: Params, options: QueryOptions = {}) => {
  const { getOtoscopies } = useOtoscopyService()

  const doQuery = async () => {
    log(`📸 Fetching otoscopy...`, { customerGid })

    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const otoscopies = await getOtoscopies({ customerGid: customerGid! })

    log(`📸 Found otoscopy...`, { customerGid })

    return otoscopies
  }

  return useQuery([hookName, customerGid], doQuery, {
    ...defaultQueryOptions,
    refetchOnMount: false,
    ...options,
    enabled: Boolean(customerGid && options?.enabled !== false),
  })
}

export { useOtoscopies }
